import { Show, SimpleShowLayout, TextField } from "react-admin";

const EntityShow = () =>(
    <Show>
        <SimpleShowLayout>
            <TextField source="pseudo" label="Pseudo" />
            <TextField source="name" label="Full name" />
        </SimpleShowLayout>
    </Show>
);

export default EntityShow;